import { useEffect, useRef, useState } from "react";
import { TimerOff } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Boşta kalma: 45 dk işlem yoksa oturum kapanır; son 60 sn uyarı + geri sayım. Son işlem zamanı localStorage'da → tüm sekmeler ortak.
export const IDLE_LIMIT_MS = 45 * 60 * 1000;
export const IDLE_WARN_MS = 60 * 1000;
export const IDLE_KEY = "pas_last_activity";
export const LOGOUT_REASON_KEY = "pas_logout_reason";
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel"];

export const touchActivity = () => { try { localStorage.setItem(IDLE_KEY, String(Date.now())); } catch { /* özel mod */ } };
const lastActivity = () => { const v = Number(localStorage.getItem(IDLE_KEY)); return v || Date.now(); };

export default function IdleGuard() {
  const { user, logout } = useAuth();
  const [left, setLeft] = useState(null);   // null → uyarı kapalı; sayı → kalan saniye
  const firing = useRef(false);

  useEffect(() => {
    if (!user) return undefined;
    touchActivity();
    let lastWrite = 0;
    const onAct = () => { const now = Date.now(); if (now - lastWrite > 5000) { lastWrite = now; touchActivity(); } };
    EVENTS.forEach((ev) => window.addEventListener(ev, onAct, { passive: true }));
    const tick = setInterval(async () => {
      const idle = Date.now() - lastActivity();
      if (idle >= IDLE_LIMIT_MS) {
        if (firing.current) return;
        firing.current = true;
        try { localStorage.setItem(LOGOUT_REASON_KEY, "idle"); } catch { /* özel mod */ }
        await logout();
        return;
      }
      setLeft(idle >= IDLE_LIMIT_MS - IDLE_WARN_MS ? Math.max(1, Math.ceil((IDLE_LIMIT_MS - idle) / 1000)) : null);
    }, 1000);
    return () => { clearInterval(tick); EVENTS.forEach((ev) => window.removeEventListener(ev, onAct)); };
  }, [user, logout]);

  if (!user || left === null) return null;
  const resume = () => { touchActivity(); setLeft(null); };
  return (
    <div className="fixed inset-0 z-[100] bg-slate-900/60 backdrop-blur-[2px] flex items-center justify-center p-4" data-testid="idle-warning" role="alertdialog" aria-modal="true">
      <div className="w-full max-w-md rounded-xl bg-white shadow-2xl border border-amber-300 p-6 space-y-4">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-amber-100 text-amber-700"><TimerOff className="w-5 h-5" /></span>
          <div>
            <div className="text-base font-bold text-slate-900">Oturumunuz kapanmak üzere</div>
            <div className="text-xs text-slate-600">45 dakikadır işlem yapılmadı.</div>
          </div>
        </div>
        <div className="text-sm text-slate-700">
          <span className="font-mono text-2xl font-bold text-amber-700" data-testid="idle-countdown">{left}</span> saniye içinde güvenlik için otomatik çıkış yapılacak.
        </div>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={() => { localStorage.setItem(LOGOUT_REASON_KEY, "manual"); logout(); }} data-testid="idle-logout-now" className="px-3 py-2 rounded-md border border-slate-300 text-sm font-semibold text-slate-700 hover:bg-slate-50">Çıkış Yap</button>
          <button type="button" autoFocus onClick={resume} data-testid="idle-resume" className="px-4 py-2 rounded-md bg-amber-600 text-white text-sm font-bold hover:bg-amber-700">Oturumu Sürdür</button>
        </div>
      </div>
    </div>
  );
}
